export enum UserRole {
    directoryAdmin = 'DirectoryAdmin',
    employee = 'Employee',
    advisor = 'Advisor',
    solutionAdmin = 'SolutionAdmin', // Not a directoryRole
}
